import { apiAdminInstance } from "../Api/ApiInstance";
import { string_to_slug } from "../helpers/Strings";

export const CreateMark = async (mark) => {
  let { nombre_marca } = mark;
  const slug = string_to_slug(nombre_marca);

  return await apiAdminInstance.post("api/nexus-main/mark/", {
    nombre_marca,
    slug,
    state: 1,
  });
};

export const ListMarks = async () => {
  return await apiAdminInstance.get("api/nexus-main/mark");
};

export const ListFilterMarks = async () => {
  return await apiAdminInstance.get(
    "api/nexus-main/mark/filter"
  );
};

export const UpdateMark = async (mark) => {
  const { id, nombre_marca, state } = mark;
  const slug = nombre_marca ? string_to_slug(nombre_marca) : nombre_marca;

  return await apiAdminInstance.put(
    "api/nexus-main/mark/" + id,
    {
      nombre_marca,
      slug,
      state,
    }
  );
};

export const DeleteMark = async (id) => {
  return await apiAdminInstance.delete(
    "api/nexus-main/mark/" + id
  );
};
